import React, { useEffect } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import './Blog.css'
import data from './blog.json'
export default function BlogList() {
    useEffect(()=>{
     console.log('data',data?.title)
    },[])
    return (
        <div>

            <section className='banner_strip'>
                <h1>Blog</h1>
            </section>

            <section className='job-page blog-page'>

                <Container>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                            <li className="breadcrumb-item active" aria-current="page">Blog</li>
                        </ol>
                    </nav>
                    <Row>
                        <Col lg={4} md={4}>
                            <div className='cards'>
                                <div className="card">
                                    <span className="close"></span>
                                    <span className="arrow"></span>
                                    <article>
                                        <h2>Elijah Green</h2>
                                        <div className="title">Bug Collector</div>
                                        <div className="pic">
                                            <img src={require('../../assets/images/i3.jpg')} alt="bg-1" />
                                        </div>

                                        <div className="desc">Elijah has collected bugs since they were six years old and now has many dozen bugs but none in their pants.</div>

                                    </article>
                                    <div className="actions">
                                        <button className="btn"><span>Read More</span></button>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col lg={4} md={4}>
                            <div className='cards'>
                                <div className="card">
                                    <span className="close"></span>
                                    <span className="arrow"></span>
                                    <article>
                                        <h2>Elijah Green</h2>
                                        <div className="title">Bug Collector</div>
                                        <div className="pic">
                                            <img src={require('../../assets/images/i3.jpg')} alt="bg-1" />
                                        </div>

                                        <div className="desc">Elijah has collected bugs since they were six years old and now has many dozen bugs but none in their pants.</div>

                                    </article>
                                    <div className="actions">
                                        <button className="btn"><span>Read More</span></button>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col lg={4} md={4}>
                            <div className='cards'>
                                <div className="card">
                                    <span className="close"></span>
                                    <span className="arrow"></span>
                                    <article>
                                        <h2>Elijah Green</h2>
                                        <div className="title">Bug Collector</div>
                                        <div className="pic">
                                            <img src={require('../../assets/images/i3.jpg')} alt="bg-1" />
                                        </div>

                                        <div className="desc">Elijah has collected bugs since they were six years old and now has many dozen bugs but none in their pants.</div>

                                    </article>
                                    <div className="actions">
                                        <button className="btn"><span>Read More</span></button>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col lg={4} md={4}>
                            <div className='cards'>
                                <div className="card">
                                    <span className="close"></span>
                                    <span className="arrow"></span>
                                    <article>
                                        <h2>Elijah Green</h2>
                                        <div className="title">Bug Collector</div>
                                        <div className="pic">
                                            <img src={require('../../assets/images/i3.jpg')} alt="bg-1" />
                                        </div>

                                        <div className="desc">Elijah has collected bugs since they were six years old and now has many dozen bugs but none in their pants.</div>

                                    </article>
                                    <div className="actions">
                                        <button className="btn"><span>Read More</span></button>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col lg={4} md={4}>
                            <div className='cards'>
                                <div className="card">
                                    <span className="close"></span>
                                    <span className="arrow"></span>
                                    <article>
                                        <h2>Elijah Green</h2>
                                        <div className="title">Bug Collector</div>
                                        <div className="pic">
                                            <img src={require('../../assets/images/i3.jpg')} alt="bg-1" />
                                        </div>

                                        <div className="desc">Elijah has collected bugs since they were six years old and now has many dozen bugs but none in their pants.</div>

                                    </article>
                                    <div className="actions">
                                        <button className="btn"><span>Read More</span></button>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col lg={4} md={4}>
                            <div className='cards'>
                                <div className="card">
                                    <span className="close"></span>
                                    <span className="arrow"></span>
                                    <article>
                                        <h2>Elijah Green</h2>
                                        <div className="title">Bug Collector</div>
                                        <div className="pic">
                                            <img src={require('../../assets/images/i3.jpg')} alt="bg-1" />
                                        </div>

                                        <div className="desc">Elijah has collected bugs since they were six years old and now has many dozen bugs but none in their pants.</div>

                                    </article>
                                    <div className="actions">
                                        <button className="btn"><span>Read More</span></button>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </div>
    )
}
